import React, { useEffect, useState } from "react";
import {
  Button,
  Typography,
  Form,
  Select,
  Input,
  Tag,
  notification,
} from "antd";
import { del, get } from "../../../api/axios";
import { Link } from "react-router-dom";
import { Popconfirm } from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { checkPermission } from "../../control-sections/auth/ProtectedRoutes";
import { onChangeTableHelper } from "../../control-sections/helper/TableHelpers";
import TableComponent from "../../control-sections/helper/TableComponent";

const Leads = () => {
  const { Title } = Typography;
  const [form] = Form.useForm();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingSearch, setLoadingSearch] = useState(false);

  const [total, setTotal] = useState(1);

  const [filterData, setFilterData] = useState({
    filter_key: "",
    filter_value: "",
  });

  const [sorter, setSorter] = useState({
    sort_by: "",
    order: "",
  });

  const columns = [
    {
      title: " Id",
      dataIndex: "id",
      sorter: (a, b) => a.id - b.id,
    },
    {
      title: "Listing Title",
      render: ({ listing }) =>
        checkPermission("update-seller-listings") ? (
          listing ? (
            <Link to={`/listings/edit/${listing.id}`}>{listing.title}</Link>
          ) : (
            ""
          )
        ) : listing.title ? (
          listing.title
        ) : (
          ""
        ),
    },
    {
      title: "Seller Name",
      render: ({ seller }) =>
        checkPermission("update-seller") ? (
          seller ? (
            <Link to={`/sellers/edit/${seller.id}`}>{seller.name}</Link>
          ) : (
            ""
          )
        ) : seller.name ? (
          seller.name
        ) : (
          ""
        ),
    },
    {
      title: "Buyer Name",
      render: ({ buyer }) =>
        checkPermission("update-buyer") ? (
          buyer ? (
            <Link to={`/buyers/edit/${buyer.id}`}>{buyer.name}</Link>
          ) : (
            ""
          )
        ) : buyer.name ? (
          buyer.name
        ) : (
          ""
        ),
    },
    {
      title: "Action",
      dataIndex: "action",
      sorter: (a, b) => a.action - b.action,
    },
    {
      title: "Extra Data",
      dataIndex: "extra_data",
      sorter: (a, b) => a.extra_data - b.extra_data,
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      sorter: (a, b) => a.created_at - b.created_at,
    },
  ];

  useEffect(() => {
    get("leads?page=1&limit=50").then((res) => {
      setData(res.data.data);
      setTotal(res.data.meta.total);
      setLoading(false);
    });
  }, []);

  const handleFilterKey = (e) => {
    setFilterData({ ...filterData, filter_key: e });
  };

  const handleFilterVal = (e) => {
    setFilterData({ ...filterData, [e.target.id]: e.target.value });
  };

  const onFilter = (values) => {
    setLoadingSearch(true);

    get(
      `leads?filter_key=${filterData.filter_key}&filter_value=${
        filterData.filter_value
      }${
        sorter.sort_by !== "" && sorter.sort_by !== undefined
          ? `&sort_by=${sorter.sort_by}`
          : ""
      }${sorter.order !== "" ? `&order=${sorter.order}` : ""}`
    )
      .then((res) => {
        setData(res.data.data);
        setTotal(res.data.meta.total);
        setLoadingSearch(false);
      })
      .catch((err) => {
        notification.error({
          message: "Error!",
          description: err.response.data.message,
        });
        setLoadingSearch(false);
      });
  };

  const clearSearch = () => {
    form.resetFields();
    setFilterData({
      filter_key: "",
      filter_value: "",
    });
    get("leads?page=1&limit=50").then((res) => {
      setData(res.data.data);
      setTotal(res.data.meta.total);
    });
  };

  const onChangeTable = (pagination, filters, sorter) => {
    setLoading(true);
    setSorter({
      ...sorter,
      sort_by: sorter.field,
      order: sorter.order == "descend" ? "desc" : "asc",
    });

    onChangeTableHelper("leads", pagination, filterData, sorter)
      .then((res) => {
        setData(res.data.data);
        setTotal(res.data.meta.total);
        setLoading(false);
      })
      .catch((err) => {
        notification.error({
          message: "Error!",
          description: err.response.data.message,
        });
        setLoading(false);
      });
  };

  return (
    <div>
      <div className="row">
        <div className="col-lg-12">
          <div className="row">
            <div className="col-lg-6">
              <Title level={2} className="text-main mb-2">
                Leads & Activity Logs
              </Title>
            </div>
          </div>
        </div>
      </div>

      <div className="grid-margin stretch-card wrapper-content">
        <Form onFinish={onFilter} layout="vertical" form={form}>
          <div className="row">
            <div className="col-12 col-lg-4">
              <Form.Item
                label="Search By"
                name="filter_key"
                rules={[
                  {
                    required: true,
                    message: "This field is required!",
                  },
                ]}
              >
                <Select
                  className="w-100"
                  showSearch
                  placeholder="select test "
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  onChange={handleFilterKey}
                  options={[
                    {
                      value: "seller_id",
                      label: "Seller Id",
                    },
                    {
                      value: "buyer_id",
                      label: "Buyer Id",
                    },
                    {
                      value: "listing_id",
                      label: "Listing Id",
                    },
                    {
                      value: "id",
                      label: "Id",
                    },
                    {
                      value: "action",
                      label: "Action",
                    },
                    {
                      value: "seller_name",
                      label: "Seller Name",
                    },
                    {
                      value: "buyer_name",
                      label: "Buyer Name",
                    },
                    {
                      value: "listing_title",
                      label: "Listing Title",
                    },
                  ]}
                />
              </Form.Item>
            </div>
            <div className="col-12 col-lg-6">
              <Form.Item
                label="Search"
                name="filter_value"
                onChange={handleFilterVal}
                rules={[
                  {
                    required: true,
                    message: "This field is required!",
                  },
                ]}
              >
                <Input placeholder="Type to search..." />
              </Form.Item>
            </div>
            <div className="col-12 col-lg-2 d-flex align-items-end">
              <Form.Item className="w-100">
                <div className="row">
                  <div className="col-8">
                    <Button
                      block
                      loading={loadingSearch}
                      type="primary"
                      htmlType="submit"
                    >
                      {loadingSearch ? "Searching" : "Search"}
                    </Button>
                  </div>
                  <div className="col-4">
                    <Button
                      onClick={clearSearch}
                      className="flex-center"
                      danger
                      type="primary"
                    >
                      <DeleteOutlined />
                    </Button>
                  </div>
                </div>
              </Form.Item>
            </div>
          </div>
        </Form>
        <TableComponent
          onChangeTable={onChangeTable}
          loading={loading}
          columns={columns}
          data={data}
          total={total}
        />
      </div>
    </div>
  );
};

export default Leads;
